<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="titleCreate">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-right-col-small="true"
      :has-sticky-col-right="true">
      <div class="has-background-white is-border">
        <form @submit.prevent.stop="submitOption()">
          <div
            v-if="lot"
            class="is-padding-bottom-small is-padding-left-large is-padding-right-large is-padding-top-xlarge">
            <div class="columns is-variable is-6">
              <div class="column columns is-gapless is-column is-space-between is-marginless is-padding-top-large is-padding-left is-padding-bottom-small">
                <div>
                  <r-label
                    style="font-size: 1.45rem !important"
                    class="has-text-grey title is-6 has-text-weight-normal"
                    :is-required="false"
                    :label="'N° DU LOT :'">
                    <span
                      style="font-size: 1.5rem"
                      class="is-margin-left-xxsmall has-text-weight-bold has-text-black ">{{ lot.ref }} - PRIX : {{ lot.sale_price_ttc }} € </span>
                  </r-label>
                </div>
                <div
                  class="is-margin-top"
                  v-if="canAddUsers && (isAdmin || isManager)">
                  <div
                    v-if="sellersCount !== null && sellersCount === 0"
                    class="column is-12 columns is-paddingless">
                    <div class="column is-12 is-margin-bottom-xsmall is-paddingless">
                      <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                        <p>Vous n'avez pas d'utilisateur.</p>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="control field has-addons"
                      v-if="!seller">
                      <div class="control is-expanded">
                        <div
                          id="selfOption"
                          class="button is-blocAdd is-fullwidth is-flex is-min-height-50"
                          :class="selfOption ? 'is-success' : ''"
                          style="justify-content: center !important; font-size: 1.13rem"
                          @click.prevent.stop="selfOption = true">
                          <span :class="selfOption ? 'has-text-white' : 'has-text-black'">Cette option est pour moi</span>
                        </div>
                      </div>
                      <div class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          @click.prevent.stop="openUserSelection('simple'); selfOption = false">
                          <span class="has-text-black">Sélectionner un vendeur</span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="seller"
                      class="columns is-gapless is-border is-padding-left-xsmall is-padding-top-small is-padding-bottom-small is-padding-right-small">
                      <div class="column">
                        <div class="is-margin-left-xxsmall is-margin-right-xxsmall">
                          <div
                            style="height: 8px !important"
                            class="title is-4">
                            <b>{{ seller.first_name }} {{ seller.last_name }}</b>
                          </div>
                          <div class="rows">
                            <div
                              v-if="seller.account.pk !== currentUser.account.pk && seller.account.name"
                              class="subtitle is-size-6">
                              {{ seller.account.name }}
                            </div>
                            <div
                              v-if="seller.account.pk == currentUser.account.pk && seller.account.name"
                              class="subtitle is-size-6">
                              {{ seller.profil | profilTypeLabel }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow has-text-right">
                        <button
                          class="button is-action is-circle"
                          @click.prevent.stop="seller = null; contact = null; selfOption = true; getContactsCount()">
                          <i class="fal fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="has-background-annonce columns is-vcentered is-gapless"
                    v-if="displayErrorMessage">
                    <div class="column is-narrow is-padding-small">
                      <span class="icon has-text-white"><i class="fas fa-engine-warning fa-lg"></i></span>
                    </div>
                    <div class="column is-padding-left-xxsmall is-padding-right-xsmall is-padding-top-xsmall is-padding-bottom-xsmall">
                      <div class="has-text-white is-italic is-size-6">
                        <span v-if="!sellerHasAccess">La société de l'utilisateur n'a pas de mandat pour ce lot.
                          <!-- <router-link v-if='isAdmin' :to="{name: 'AccessCreate', query: accessQuery }" class="has-text-white is-underline">Créer un mandat</router-link> -->
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="seller && contactsCount !== null && contactsCount === 0"
                  class="column is-12 columns is-paddingless is-gapless">
                  <div class="column is-12 is-paddingless">
                    <div class="notification is-warning is-size-6 is-padding-top-small is-padding-bottom-small">
                      <p>
                        {{ isSeller || selfOption ? 'Vous ne possédez' : 'Ce vendeur ne possède' }} pas de contact
                        actuellement.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="is-margin-top-xsmall">
                  <div
                    class=""
                    v-if="!contact">
                    <div class="field has-addons">
                      <div
                        v-if="contactsCount && contactsCount > 0"
                        class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          :class="isDisabled"
                          @click.prevent.stop="openContactSelection('simple')"
                          :disabled="isDisabled">
                          <span class="has-text-black"> Sélectionner un contact</span>
                        </button>
                      </div>
                      <div class="control is-expanded">
                        <button
                          class="button is-blocAdd is-fullwidth"
                          style="justify-content: center !important; font-size: 1.13rem"
                          :class="isDisabled"
                          @click.prevent.stop="openNewContactQuickview()"
                          :disabled="isDisabled">
                          <span class="has-text-black"> Créer un nouveau contact</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="contact"
                    class="is-padding-left-xsmall is-padding-top-small is-padding-bottom-small is-padding-right-small is-border">
                    <div class="columns is-gapless">
                      <div class="column">
                        <div class="is-margin-left-xxsmall is-margin-right-xxsmall">
                          <div
                            style="height: 8px !important"
                            class="title is-4">
                            <b>{{ contact.first_name }} {{ contact.last_name }}</b>
                          </div>
                          <div class="rows">
                            <div>
                              <div>
                                <span class="has-text-weight-bold is-size-6">Mail : </span>
                                <span class="is-size-6">{{ contact.email || 'NC' }}</span>
                                -
                                <span class="has-text-weight-bold is-size-6">Téléphone : </span>
                                <phone-number
                                  v-if="contact.phone"
                                  :phone-class="'is-size-6'"
                                  :phone="contact.phone"></phone-number>
                              </div>
                              <div>
                                <span class="has-text-weight-bold is-size-6">Adresse : </span>
                                <span class="is-size-6">{{ contact.address|prettyInlineAddress }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-narrow">
                        <button
                          class="button is-action is-circle"
                          @click.prevent.stop="contact = null">
                          <i class="fal fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <date-picker
                  class="is-margin-top-xsmall is-margin-bottom"
                  :model="previous_sign_date"
                  :style-placeholder="true"
                  :placeholder-option="true"
                  :style-version="2"
                  @input="previous_sign_date = $event"
                  :placeholder="'Date de signature prévue (optionnel)'">
                </date-picker>
              </div>
              <div class="column columns is-gapless is-column is-space-between is-marginless">
                <div
                  style="width: 100% !important; height: 100% !important"
                  v-if="lot && lot.program.picture"
                  class="is-vcentered is-gapless">
                  <div :style="backgroundImageStyle(lot.program.picture)"></div>
                </div>
                <div
                  v-else
                  class="column columns is-gapless is-column is-space-between is-marginless">
                  <img
                    class="full-background"
                    src="img/placeholder/place-holder-program--small-min.jpg">
                </div>
              </div>
            </div>
          </div>
          <template v-if="isPromoteur && openComment">
            <div class="has-background-white-bis is-margin-top-small is-padding-top-small is-padding-left-xlarge is-padding-right-large is-padding-bottom">
              <r-label
                class="is-uppercase title is-6 semidarkcolor-title"
                :is-required="false"
                :label="'AJOUTER COMMENTAIRE'"></r-label>
              <div
                v-if="!openCommentWysi && comment"
                @click="openCommentWysi = true"
                class="vadDiscussion is-border-top"
                style="cursor: pointer;">
                <div
                  class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left is-border-right is-border-bottom">
                  <div
                    class="content"
                    v-if="comment"
                    v-html="comment"></div>
                  <div class="actionsOnRow actionsOnRow--vertical">
                    <div class="">
                      <button
                        @click="openCommentWysi = true"
                        class="is-min-height-full">
                        <span class="icon is-small">
                          <i class="fal fa-edit"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="is-border-top columns is-gapless is-margin-top-small is-border-right is-border-bottom ">
                <div class="column">
                  <wysiwyg-editor
                    style="background-color: white"
                    :light="true"
                    :tooltip-top="true"
                    :model="comment"
                    @change="val => comment = val"
                    class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
                  </wysiwyg-editor>
                </div>
                <div class="actionsOnRow actionsOnRow--vertical">
                  <div>
                    <button
                      @click="createCom()"
                      type="button"
                      class="button"
                      :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                      :disabled="(baseComment === comment)">
                      <span class="icon is-small">
                        <i
                          v-if="loadComment"
                          class="fas fa-spinner fa-spin"></i>
                        <i
                          v-else
                          class="fal fa-save"></i>
                      </span>
                    </button>
                  </div>
                  <div class="">
                    <button
                      :disabled="!baseComment"
                      type="button"
                      :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                      @click="comment ? openCommentWysi = false : null; comment = baseComment">
                      <span class="icon is-small"><i class="fal fa-times"></i></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <submit-sticky-buttons
            @submit="submitOption"
            :disabled="!sellerHasAccess"
            :loading="submitLoading"
            button-id="accessForm"></submit-sticky-buttons>
        </form>
      </div>
      <template
        v-if="lot"
        slot="right-col-small">
        <div
          v-if="lot.options.length"
          class="is-border is-border--optioned is-border--darken2 has-background-optioned has-text-text is-margin-bottom">
          <div class="is-padding is-12 is-size-4 is-border-bottom is-border--optioned is-border--darken1">
            <b>{{ lot.options.length }} option(s)</b> en cours sur le lot
            <p class="is-margin-top-small is-size-5">
              Votre option sera mise en liste d'attente
            </p>
          </div>
          <div class="is-padding">
            <div class="subtitle is-margin-bottom-xsmall">
              Votre option débutera au :
            </div>
            <div class="is-size-4">
              <b class="has-text-weight-medium">{{ lot.options[lot.options.length - 1].end_date |
                prettyFullDatetime }}</b>
            </div>
          </div>
        </div>
        <div
          v-if="hasAccess || lot.program.remuneration"
          class="is-border is-border--optioned is-border--darken2 has-background-optioned has-text-text is-margin-bottom">
          <div class="is-padding is-12 is-size-4 is-border-bottom is-border--optioned is-border--darken1">
            Votre taux de commercialisation sur ce lot est de :
            <span v-if="hasAccess && lot.bonus">
              {{ hasAccess.remuneration + lot.bonus }}
            </span>
            <span v-else-if="hasAccess && !lot.bonus">
              {{ hasAccess.remuneration }}
            </span>
            <span v-else>
              {{ lot.program.remuneration }}
            </span>
            % HT
          </div>
        </div>
        <div
          v-if="program"
          class="is-border has-text-justified">
          <div class="is-padding has-background-light--darken1">
            <div class="title is-4">
              <b>Le saviez-vous ?</b>
            </div>
          </div>
          <div class="has-text-grey is-padding">
            <p>L'option vous permet de vous attribuer le lot durant une période définie.</p>
            <ul
              class="is-padding-left"
              style="list-style:disc">
              <li>Les options sur ce programme ont une durée de <b>{{ program.option_period }}h</b> (hors dimanche et jours fériés).</li>
            </ul>
            <p class="is-margin-bottom-xsmall"></p>
            <p>Vous devez sélectionner le contact pour lequel vous souhaitez déposer l’option.</p>
            <p>
              L'utilisateur doit être l'utilisateur référent du contact. Si le contact ne remonte pas vous devez vérifier que celui-ci lui est bien attribué.
            </p>
            <ul
              class="is-padding-left"
              style="list-style:disc">
              <li>Si le lot est actuellement disponible, votre option sera active dès sa validation.</li>
              <li>Si le lot est actuellement optionné, votre option sera en file d'attente et nous vous informerons de la période de validité par mail.</li>
            </ul>
            <p class="is-margin-bottom-xsmall"></p>
            <p>Vadimm vous garantit la protection de vos données contacts : uniquement le Nom et prénom de votre contact seront divulgués au promoteur, et rien d'autre !</p>
            <!-- <p><b>« Comment poser une option ? »</b></p>
            <p class="is-margin-top-small">Vous devez sélectionner le contact pour lequel vous souhaitez déposer l’option.
              Si le lot est actuellement disponible, votre option sera active dès sa validation.
              Si le lot est actuellement optionné, nous vous informerons de la période de sa validité par mail.
              Les options sur ce programme ont une durée de {{ program.option_period }}h (hors dimanche et jours fériés).
              Vous pourrez effectuer une demande de prolongement de votre option en contactant l’administrateur du programme.</p> -->
          </div>
        </div>
      </template>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues, Option, Quickview } from '@/mixins'

export default {
  name: 'OptionCreate',
  mixins: [DefaultValues, Option, Quickview],
  data () {
    return {
      duplicateContact: false,
      duplicateDenunciation: false,
      savedOwnContactsCount: null
    }
  },
  computed: {
    hasAccess () {
      if (this.accessesList && this.accessesList.length) {
        return this.accessesList.find(x => {
          if (x.account.pk === this.currentUser.account.pk) {
            return x
          } else {
            return false
          }
        })
      } else {
        return false
      }
    }
  },
  watch: {
    async quickview ({ mode, params, results }) {
      if (results && mode === 'USER_SELECTION') {
        if (results.entities.length) {
          if ('account_type' in results.entities[0]) {
            let user = await this.getUser(results.entities[0].first_admin.pk)
            await this.getUserAllotment(user)
            this.seller = Object.assign({}, user)
          } else {
            await this.getUserAllotment(results.entities[0])
            this.seller = Object.assign({}, results.entities[0])
          }
          this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un utilisateur')
        }
      } else if (mode === 'CONTACT_SELECTION' && results) {
        if (results.entities.length) {
          this.addContact(results.entities[0])
        } else {
          this.$toasted.global.danger('Veuillez sélectionner un contact')
        }
      } else if (mode === 'CONTACT_CREATE' && results) {
        let check = 'CONTACT_CREATE'
        this.verifBeforeCreateContact(results.contact, check)
      } else if (mode === 'CONTACT_CHECK_CREATE' && results) {
        let doublon = true
        this.createContact(results.contact, doublon)
      }
    }
  },
  methods: {
    async addContact (contact) {
      this.contact = await this.returnContact(contact.pk)
      this.getContactsCount()
      this.$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })
    },
    async returnContact (id) {
      try {
        let { data } = await this.$api.getOne(this.$resources.CONTACT, id)
        return data
      } catch (err) {
        console.log(err)
      }
    },
    // Data présent dans OptionMixin.js
    async createCom () {
      this.isButtonClicked = true
      this.loadComment = true
      try {
        this.$toasted.global.success('Commentaire mis à jour')
        this.loadComment = false
        this.openCommentWysi = !this.comment
        this.baseComment = this.comment
      } catch (e) {
        console.log(e)
        this.loadComment = true
        this.$toasted.global.danger('Erreur lors de la mise à jour')
      }
    },
    backgroundImageStyle (picture) {
      return {
        backgroundImage: `url('${picture.path}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100%',
        width: '100%'
      }
    }
  }
}
</script>

<style scoped>
.button.is-blocAdd {
  min-height: 50px !important
}

.button.is-blocAdd span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.semidarkcolor-title {
  color: #363636;
  font-weight: 500;
  line-height: 1.125;
}

.full-background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}
</style>
